export const MAX_REJECT_REASON_LENGTH = 500;

export const REJECT_REASON_REQUIRED_MESSAGE = "Please enter a reason.";
export const REJECT_REASON_TOO_LONG_MESSAGE = `Reason must be ${MAX_REJECT_REASON_LENGTH} characters or fewer.`;

export const normalizeRejectReason = (value) => (value ?? "").trim();

export const validateRejectReason = (value) => {
  const reason = normalizeRejectReason(value);
  if (!reason) return REJECT_REASON_REQUIRED_MESSAGE;
  if (reason.length > MAX_REJECT_REASON_LENGTH) return REJECT_REASON_TOO_LONG_MESSAGE;
  return "";
};
